import styled from 'styled-components';

const Divider = styled('div')`
  height: 1px;
  width: 100%;
  background: ${({ theme }) => theme.colors.grey2};
  margin: 0 0 8px 0;
`;

export default Divider;
